module.exports = __webpack_public_path__ + "static/media/sample_06.715942de.jpg";